<ng-container *puSpinner="isLoading()">
  <div class="pt-courses-report__header">
    <h4 class="pt-courses-report__header-text">
      {{ 'myTeam.coursesReport.dialog.header' | translate }}
    </h4>
    <button
      class="pt-courses-report__close"
      type="button"
      puButton
      size="m"
      uiType="quaternary"
      [onlyIcon]="true"
      (click)="close()"
    >
      <pu-icon
        iconName="close"
        size="16"
      />
    </button>
  </div>
  <div class="pt-courses-report__body">
    @if (userInfo()) {
      <div class="pt-courses-report__user">
        <pu-avatar
          size="40"
          [image]="userInfo().picture"
          [nameFirstLetter]="userInfo().email && userInfo().email[0]"
        />
        <div>
          <div>{{ userInfo().fullName }}</div>
          <div class="pt-courses-report__user-position">{{ userInfo().position }}</div>
        </div>
      </div>

      <div class="pt-courses-report__user-details">
        <div>
          <dt>{{ 'myTeam.coursesReport.dialog.userEmail' | translate }}</dt>
          <dd>{{ userInfo().email }}</dd>
        </div>
        <div>
          <dt>{{ 'myTeam.coursesReport.dialog.userTeam' | translate }}</dt>
          <dd>{{ userInfo().team }}</dd>
        </div>
        <div>
          <dt>{{ 'myTeam.coursesReport.dialog.userDirectManager' | translate }}</dt>
          <dd>{{ userInfo().directManager?.fullName }}</dd>
        </div>
        <div>
          <dt>{{ 'myTeam.coursesReport.dialog.userFunctionalManager' | translate }}</dt>
          <dd>{{ userInfo().functionalManager?.fullName }}</dd>
        </div>
      </div>
    }

    <form
      class="pt-courses-report__body-form"
      [formGroup]="filtersForm"
    >
      <pu-simple-input
        class="pt-courses-report__body-form-search"
        formControlName="search"
        iconName="search"
        [placeholder]="'myTeam.coursesReport.dialog.form.search' | translate"
      />

      <pu-select
        formControlName="courseType"
        [items]="courseTypes | withAllOption"
        [label]="'myTeam.coursesReport.dialog.form.type' | translate"
      />

      <pu-select
        formControlName="courseStatus"
        [items]="statuses | withAllOption"
        [label]="'myTeam.coursesReport.dialog.form.status' | translate"
      />
    </form>

    <table
      mat-table
      [dataSource]="tableData()"
    >
      <ng-container matColumnDef="id">
        <th
          *matHeaderCellDef
          mat-header-cell
        >
          {{ 'myTeam.coursesReport.dialog.table.id' | translate }}
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          {{ element.courseId }}
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th
          *matHeaderCellDef
          mat-header-cell
        >
          {{ 'myTeam.coursesReport.dialog.table.courseName' | translate }}
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          {{ element.courseName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th
          *matHeaderCellDef
          mat-header-cell
        >
          {{ 'myTeam.coursesReport.dialog.table.courseType' | translate }}
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          {{ 'dictionary.courseTypes.' + element.courseType | translate }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th
          *matHeaderCellDef
          mat-header-cell
        >
          {{ 'myTeam.coursesReport.dialog.table.courseStatus' | translate }}
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          <pu-user-status
            [type]="element.courseStatus"
            [i18nPrefix]="'dictionary.usersCourseStatuses'"
          />
        </td>
      </ng-container>

      <tr
        *matHeaderRowDef="displayedColumns"
        mat-header-row
      ></tr>
      <tr
        *matRowDef="let row; columns: displayedColumns;"
        mat-row
      ></tr>
    </table>

    @if (itemsCount() > filtersForm.controls.limit.value) {
      <mat-paginator
        class="pt-courses-report__body-paginator"
        aria-label="Select page"
        [length]="itemsCount()"
        [pageSize]="filtersForm.value.limit"
        [showFirstLastButtons]="true"
        [hidePageSize]="true"
        [pageIndex]="filtersForm.value.page - 1"
        (page)="onPageChange($event)"
      />
    }
    <div class="pt-courses-report__body-actions">
      <button
        type="button"
        puButton
        size="l"
        uiType="secondary"
        (click)="close()"
      >
        {{ 'myTeam.coursesReport.dialog.actions.close' | translate }}
      </button>

    </div>
  </div>
</ng-container>
